// ============================================================
// CENTRAL CONTENT MAP — Shakti Love Music
// Replace image URLs and copy with production assets.
// Bilingual EN / ES. Fallback = EN.
// ============================================================

export const IMAGES = {
  hero: "https://customer-assets-jai6qajn.emergentagent.net/job_dj-sito-booking/artifacts/pzjwcex9_shaktylove.jpg",
  portrait: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/4ca89d39f70a5c341430ac699733e9055bceb7592ba5863c9a7dc8f6353c175e.jpeg",
  portraitAbout: "https://customer-assets-jai6qajn.emergentagent.net/job_dj-sito-booking/artifacts/biomd9pe_shaktilovemusicdj.jpg",
  servicesBg: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/1df648bfdcfd1240ce2f119861c9270495011e18b5359a4b2ed5959786751252.jpeg",
  moodTexture: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/7f1ef36fdaec3a34ec961299d4ec2c8e1551c748487435bf6210419e907e99fd.jpeg",
  gallery: [
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/2e80168ec5ea8c3d2b19e7ba127601a61cc01bce80a66b73f0c6f4a217b3c16d.jpeg", w: 1024, h: 1024 },
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/490556caecda61c8ce0e6ead128f51a90699c9dc9fe4cac7b9ef17354496d7e4.jpeg", w: 848, h: 1264 },
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/51220c501b44e50ea8cda7c853d543c4603333d194a9579fd08e8024c49a12c9.jpeg", w: 1024, h: 1024 },
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/fa676dee9e85a158ad48d7c804a2b98ca0a1121638c477e9ef06db720b5b226d.jpeg", w: 1024, h: 1024 },
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/0ed6c3534eb96235dcf0c18bab71b8bbd64ca8ce8e2c508e370c8d00968fd5d2.jpeg", w: 848, h: 1264 },
    { src: "https://static.prod-images.emergentagent.com/jobs/44adfa66-07a6-454a-b444-31c92bf8280b/images/1df648bfdcfd1240ce2f119861c9270495011e18b5359a4b2ed5959786751252.jpeg", w: 1264, h: 848 },
  ],
};

// Demo embeds — replace with real Shakti Love Music links in production.
export const EMBEDS = {
  soundcloudUrl: "https://soundcloud.com/shakti-love-music/sunsetritualsvol-1",
  youtubeId: "jfKfPfyJRdk",
  instagram: "https://www.instagram.com/shakti_love_music/",
  facebook: "https://www.facebook.com/shakti.love.dj",
  soundcloudProfile: "https://soundcloud.com/shakti-love-music?utm_source=mobi&utm_campaign=social_sharing&si=47495a942aa9440884f2f7d4632d517e",
  youtubeChannel: "https://youtube.com",
};

export const NAV = [
  { path: "/", key: "home" },
  { path: "/about", key: "about" },
  { path: "/music", key: "music" },
  { path: "/services", key: "services" },
  { path: "/gallery", key: "gallery" },
  { path: "/events", key: "events" },
  { path: "/contact", key: "contact" },
];

export const CONTENT = {
  en: {
    brand: "Shakti Love Music",
    nav: { home: "Home", about: "About", music: "Music", services: "Services", gallery: "Gallery", events: "Events", contact: "Contact" },
    cta: { book: "Book the session", bookShort: "Book now", listen: "Listen", explore: "Explore", viewAll: "View all", getInTouch: "Get in touch" },
    hero: {
      overline: "DEEJAY · Sunset Sessions",
      line1: "Where the light",
      line2: "melts into",
      line3: "sound.",
      sub: "An emotional journey of warm, organic house — crafted for sunsets, shorelines and the moments in between.",
      scroll: "Scroll to feel it",
    },
    marquee: ["Sunset Sessions", "Private Events", "Lounge & Poolside", "Festivals", "Beach Clubs"],
    intro: {
      overline: "The Identity",
      title: "Music as a golden hour ritual.",
      body: "Shakti Love Music is the signature of a DEEJAY who reads the room like the sky reads the sun — slowly, deliberately, warmly. Every set is an arc: a gentle rise, an open horizon, and a glow that lingers long after the last track.",
      link: "Read the story",
    },
    featured: {
      overline: "Featured Mix",
      title: "A set for the fading light",
      body: "Organic house, downtempo textures and a heartbeat that never rushes. Press play and let the horizon do the rest.",
    },
    servicesPreview: {
      overline: "The Experience",
      title: "Sound for every kind of gathering",
      items: [
        { t: "Sunset Sessions", d: "Golden-hour sets for beach clubs, rooftops and shoreline lounges." },
        { t: "Private Events", d: "Weddings and intimate celebrations shaped around your story." },
        { t: "Poolside & Lounge", d: "Warm, unhurried grooves for daytime and twilight ambience." },
        { t: "Clubs & Festivals", d: "Energetic yet elegant journeys built to move a crowd." },
      ],
    },
    live: {
      overline: "Live Experience",
      title: "See the room breathe",
      body: "A glimpse of the energy — recorded live where the music met the moment.",
    },
    eventsPreview: {
      overline: "On the Horizon",
      title: "Upcoming sessions",
      empty: "New dates are being confirmed. Check back soon.",
    },
    finalCta: {
      overline: "Let's create something",
      title: "Bring the sunset to your event.",
      body: "Tell me about your gathering and I'll craft the sound that fits its light.",
    },
    about: {
      overline: "About",
      title: "A DEEJAY chasing the golden hour.",
      p1: "Shakti Love Music began where most good things do — at the edge of the sea, at the exact moment the day exhales. What started as a personal ritual grew into a signature sound: warm, organic, and unafraid of stillness.",
      p2: "Rooted in organic house and downtempo, the sets are built like landscapes. There is space to breathe, room to feel, and always a horizon to move toward. The goal is never to fill a room with noise, but to fill a moment with meaning.",
      p3: "From intimate shoreline weddings to festival stages under open skies, the intention stays the same: music that makes people feel held, present, and alive.",
      manifestoTitle: "The philosophy",
      chapters: [
        { t: "Read the light", d: "Every set follows the sun. The music rises, opens and softens with the sky." },
        { t: "Warmth over volume", d: "Emotion is not loud. It is textured, patient and deeply human." },
        { t: "Space to feel", d: "Silence and breath are instruments too. The pauses matter as much as the drops." },
      ],
    },
    music: {
      overline: "Music",
      title: "Mixes made for the horizon.",
      body: "A curated selection of sunset sets and organic house journeys. Headphones recommended, sea view optional but encouraged.",
      soundcloudTitle: "Featured on SoundCloud",
      more: "More on SoundCloud",
    },
    servicesPage: {
      overline: "Services",
      title: "How we can work together.",
      body: "Each experience is tailored — from the first track of the afternoon to the final glow of the night.",
      list: [
        { t: "Sunset Sessions", d: "Signature golden-hour performances for beach clubs, rooftops and shoreline venues. Warm, flowing, unforgettable.", tag: "01" },
        { t: "Private Events", d: "Weddings, anniversaries and intimate celebrations, soundtracked with intention and elegance.", tag: "02" },
        { t: "Poolside & Lounge", d: "Daytime and twilight ambience — unhurried organic grooves that let conversation breathe.", tag: "03" },
        { t: "Clubs & Festivals", d: "Elevated, energetic journeys for larger crowds, always keeping the emotional thread intact.", tag: "04" },
      ],
      note: "Custom formats, extended sets and B2B collaborations available on request.",
    },
    galleryPage: {
      overline: "Gallery",
      title: "Moments, in warm light.",
      body: "A visual diary of sessions, shorelines and the people who danced through them.",
      close: "Close",
    },
    eventsPage: {
      overline: "Events",
      title: "Where to find the sound.",
      upcoming: "Upcoming",
      tickets: "Tickets & info",
      empty: "New dates coming soon.",
      archiveTitle: "Past sessions",
      archiveBody: "Browse the sessions that shaped recent seasons, collected month by month.",
      archiveLink: "View archive",
      archiveOverline: "Archive",
      archivePageTitle: "Past sessions, month by month.",
      archivePageBody: "A growing record of rooms, rooftops and shorelines where the sound has travelled.",
      backToEvents: "Back to upcoming events",
      archiveEmpty: "The archive will grow with each finished session.",
    },
    contact: {
      overline: "Booking",
      title: "Let's talk about your event.",
      body: "Share the details below. I read every message personally and reply within a few days.",
      directTitle: "Get in touch directly",
      form: {
        name: "Your name",
        email: "Email",
        eventType: "Type of event",
        eventTypePlaceholder: "Select an event type",
        eventTypes: ["Private party", "Wedding", "Sunset bar", "Lounge", "Poolside", "Club", "Festival", "Other"],
        date: "Event date",
        location: "Location",
        message: "Tell me about it",
        messagePlaceholder: "Venue, vibe, timing, number of guests…",
        submit: "Send request",
        sending: "Sending…",
      },
      success: { title: "Request received", body: "Thank you — your booking request is in. I'll be in touch soon." },
      errors: {
        name: "Please enter your name.",
        email: "Please enter a valid email.",
        eventType: "Please choose an event type.",
        location: "Please add a location.",
        message: "Please add a short message.",
        generic: "Something went wrong. Please try again.",
        rate: "Too many requests. Please try again later.",
      },
    },
    footer: {
      tagline: "Sunset sessions & organic house.",
      nav: "Navigate",
      social: "Follow",
      contact: "Contact",
      rights: "All rights reserved.",
      built: "Placeholder content — replace before launch.",
    },
  },
  es: {
    brand: "Shakti Love Music",
    nav: { home: "Inicio", about: "Sobre mí", music: "Música", services: "Servicios", gallery: "Galería", events: "Eventos", contact: "Contacto" },
    cta: { book: "Reserva la sesión", bookShort: "Reservar", listen: "Escuchar", explore: "Explorar", viewAll: "Ver todo", getInTouch: "Contactar" },
    hero: {
      overline: "DEEJAY · Sesiones al Atardecer",
      line1: "Donde la luz",
      line2: "se funde con el",
      line3: "sonido.",
      sub: "Un viaje emocional de house cálido y orgánico — creado para atardeceres, orillas y los momentos intermedios.",
      scroll: "Desliza para sentirlo",
    },
    marquee: ["Sesiones al Atardecer", "Eventos Privados", "Lounge y Piscina", "Festivales", "Beach Clubs"],
    intro: {
      overline: "La Identidad",
      title: "La música como ritual de la hora dorada.",
      body: "Shakti Love Music es la firma de una DEEJAY que lee el ambiente como el cielo lee al sol — despacio, con intención, con calidez. Cada sesión es un arco: un ascenso suave, un horizonte abierto y un resplandor que permanece mucho después del último tema.",
      link: "Lee la historia",
    },
    featured: {
      overline: "Mix Destacado",
      title: "Una sesión para la luz que se apaga",
      body: "House orgánico, texturas downtempo y un latido que nunca tiene prisa. Dale al play y deja que el horizonte haga el resto.",
    },
    servicesPreview: {
      overline: "La Experiencia",
      title: "Sonido para cada tipo de encuentro",
      items: [
        { t: "Sesiones al Atardecer", d: "Sets de hora dorada para beach clubs, azoteas y lounges frente al mar." },
        { t: "Eventos Privados", d: "Bodas y celebraciones íntimas creadas en torno a tu historia." },
        { t: "Piscina y Lounge", d: "Ritmos cálidos y pausados para ambientes de día y crepúsculo." },
        { t: "Clubs y Festivales", d: "Viajes enérgicos pero elegantes, hechos para mover a la gente." },
      ],
    },
    live: {
      overline: "Experiencia en Vivo",
      title: "Mira respirar la pista",
      body: "Un vistazo a la energía — grabado en directo donde la música se encontró con el momento.",
    },
    eventsPreview: {
      overline: "En el Horizonte",
      title: "Próximas sesiones",
      empty: "Se están confirmando nuevas fechas. Vuelve pronto.",
    },
    finalCta: {
      overline: "Creemos algo juntos",
      title: "Lleva el atardecer a tu evento.",
      body: "Cuéntame sobre tu encuentro y crearé el sonido que encaje con su luz.",
    },
    about: {
      overline: "Sobre mí",
      title: "Una DEEJAY que persigue la hora dorada.",
      p1: "Shakti Love Music nació donde nacen casi todas las cosas buenas — al borde del mar, en el instante exacto en que el día exhala. Lo que empezó como un ritual personal se convirtió en un sonido propio: cálido, orgánico y sin miedo a la calma.",
      p2: "Con raíces en el house orgánico y el downtempo, los sets se construyen como paisajes. Hay espacio para respirar, lugar para sentir y siempre un horizonte hacia el que avanzar. El objetivo nunca es llenar una sala de ruido, sino llenar un momento de sentido.",
      p3: "Desde bodas íntimas frente al mar hasta escenarios de festival bajo cielos abiertos, la intención sigue siendo la misma: música que hace sentir a la gente acogida, presente y viva.",
      manifestoTitle: "La filosofía",
      chapters: [
        { t: "Leer la luz", d: "Cada set sigue al sol. La música asciende, se abre y se suaviza con el cielo." },
        { t: "Calidez sobre volumen", d: "La emoción no es ruidosa. Es texturada, paciente y profundamente humana." },
        { t: "Espacio para sentir", d: "El silencio y la respiración también son instrumentos. Las pausas importan tanto como los drops." },
      ],
    },
    music: {
      overline: "Música",
      title: "Mixes hechos para el horizonte.",
      body: "Una selección de sets al atardecer y viajes de house orgánico. Auriculares recomendados, vista al mar opcional pero deseable.",
      soundcloudTitle: "Destacado en SoundCloud",
      more: "Más en SoundCloud",
    },
    servicesPage: {
      overline: "Servicios",
      title: "Cómo podemos trabajar juntos.",
      body: "Cada experiencia es a medida — desde el primer tema de la tarde hasta el último resplandor de la noche.",
      list: [
        { t: "Sesiones al Atardecer", d: "Actuaciones de hora dorada para beach clubs, azoteas y espacios frente al mar. Cálidas, fluidas, inolvidables.", tag: "01" },
        { t: "Eventos Privados", d: "Bodas, aniversarios y celebraciones íntimas, con una banda sonora llena de intención y elegancia.", tag: "02" },
        { t: "Piscina y Lounge", d: "Ambiente de día y crepúsculo — grooves orgánicos y pausados que dejan respirar la conversación.", tag: "03" },
        { t: "Clubs y Festivales", d: "Viajes elevados y enérgicos para grandes públicos, manteniendo siempre el hilo emocional.", tag: "04" },
      ],
      note: "Formatos personalizados, sets extendidos y colaboraciones B2B disponibles a petición.",
    },
    galleryPage: {
      overline: "Galería",
      title: "Momentos, en luz cálida.",
      body: "Un diario visual de sesiones, orillas y las personas que bailaron a través de ellas.",
      close: "Cerrar",
    },
    eventsPage: {
      overline: "Eventos",
      title: "Dónde encontrar el sonido.",
      upcoming: "Próximos",
      tickets: "Entradas e info",
      empty: "Nuevas fechas muy pronto.",
      archiveTitle: "Sesiones pasadas",
      archiveBody: "Explora las sesiones de las últimas temporadas, reunidas mes a mes.",
      archiveLink: "Ver archivo",
      archiveOverline: "Archivo",
      archivePageTitle: "Sesiones pasadas, mes a mes.",
      archivePageBody: "Un registro vivo de salas, azoteas y orillas donde ha viajado el sonido.",
      backToEvents: "Volver a próximos eventos",
      archiveEmpty: "El archivo crecerá con cada sesión terminada.",
    },
    contact: {
      overline: "Reservas",
      title: "Hablemos de tu evento.",
      body: "Comparte los detalles abajo. Leo cada mensaje personalmente y respondo en pocos días.",
      directTitle: "Contacto directo",
      form: {
        name: "Tu nombre",
        email: "Email",
        eventType: "Tipo de evento",
        eventTypePlaceholder: "Selecciona un tipo de evento",
        eventTypes: ["Fiesta privada", "Boda", "Sunset bar", "Lounge", "Piscina", "Club", "Festival", "Otro"],
        date: "Fecha del evento",
        location: "Ubicación",
        message: "Cuéntame más",
        messagePlaceholder: "Lugar, ambiente, horario, número de invitados…",
        submit: "Enviar solicitud",
        sending: "Enviando…",
      },
      success: { title: "Solicitud recibida", body: "Gracias — tu solicitud de reserva ha llegado. Me pondré en contacto pronto." },
      errors: {
        name: "Por favor, introduce tu nombre.",
        email: "Por favor, introduce un email válido.",
        eventType: "Por favor, elige un tipo de evento.",
        location: "Por favor, añade una ubicación.",
        message: "Por favor, añade un breve mensaje.",
        generic: "Algo salió mal. Inténtalo de nuevo.",
        rate: "Demasiadas solicitudes. Inténtalo más tarde.",
      },
    },
    footer: {
      tagline: "Sesiones al atardecer y house orgánico.",
      nav: "Navegar",
      social: "Sígueme",
      contact: "Contacto",
      rights: "Todos los derechos reservados.",
      built: "Contenido de ejemplo — reemplazar antes del lanzamiento.",
    },
  },
};
